import classNames from "classnames";
import { Page } from "components/atoms";
import {
  SmallPromoBlockModel,
  FullWidthPromoTextBlock,
  SplitImageTextCarouselBlockModel,
  FullWidthPromoImageTextBlock,
  TextEditorWithImageGalleryBlock
} from ".";
import styles from "./ContentBlocks.module.css";
import classnames from "classnames";
import React, { useEffect, useLayoutEffect } from "react";
import uuid from "react-uuid";
import { VideoCarousel } from "components/organisms/VideoCarousel";
import { TabbedContentBlock } from "./components/TabbedContentBlock";
import $ from 'jquery';


export interface ContentBlocksProps {
  isDesktop: boolean;
  className?: string;
  blocks: any[];
  id: string | number;
  ShowCaptions: boolean;
  ShowSidebar: boolean;
}

const _ContentBlocks = ({
  ShowSidebar,
  isDesktop,
  ShowCaptions,
  id,
  className = "",
  blocks,
  ...props
}: ContentBlocksProps) => {

  useLayoutEffect(() => {
    Array.from(document.querySelectorAll('.ContentBlock .postcontent a')).forEach(element => {
      element.classList.add('button-2022')
    });
  }, [])

  return (
    <div key={`ContentBlock-${id}`} className={classnames(styles.ContentBlocks, 'ContentBlock')} {...props}>
      {blocks.map(({ Type, IsPromoBlock, ...block }, i) => {
        if (Type === "SmallPromoBlockModel")
          return (
            <Page 
            key={`Page-SmallPromoBlockModel-Wraper-${i}-${uuid()}`} 
            className="noPadding"
            contentOrientation={ShowSidebar ? "unset" : "center"}
            >
              <div className={isDesktop ? "col-8" : "col-12"}>
                <SmallPromoBlockModel
                  className={classNames(styles.smallpromoblockmodel)}
                  {...block}
                />
              </div>
            </Page>
          );
        if (Type === "FullWidthPromoTextBlockModel") {
          return IsPromoBlock ?
            <FullWidthPromoTextBlock
              key={`block-${Type}-${uuid()}`}
              {...block}
            />
            :
            <FullWidthPromoImageTextBlock
              key={`block-${Type}-${uuid()}`}
              {...block}
            />
        }
        if (Type === "SplitImageTextCarouselBlockModel")
          return (
            <div key={`block-${i}-${uuid()}`} className="ContentBlock">
              <SplitImageTextCarouselBlockModel
                {...block}
              />
            </div>
          );
        if (Type === "TextEditorWithImageGalleryBlockModel")
          return (
            <div key={`block-${Type}-${uuid()}`} className={classNames(styles.TextEditorWithImageGalleryBlockModel)}>
              <TextEditorWithImageGalleryBlock
                ShowSidebar={ShowSidebar}
                ShowCaptions={ShowCaptions}
                {...block}
              />
            </div>
          )
        if (Type === "VideoCarouselBlockModel" && block.VideosLinkPool.length) return (
          <div key={`block-${Type}-${uuid()}`} className={styles.VideoCarouselBlockModelContainer}>
            <Page className="noPadding" key="VideoCarouselBlockModel">
              <VideoCarousel
                isDesktop={isDesktop} {...block} />
            </Page>
          </div>
        )
        if (Type === "TabbedContentBlockModel" && block.TabLinkPool?.length) return (
          <div key={`block-${Type}-${uuid()}`}
            className={classNames(styles.TabbedContentBlockModelContainer, "slide-up")}
          >
            <TabbedContentBlock
              isDesktop={isDesktop}
              {...block} />
          </div>
        )

        return null;
      })}
    </div>
  );
};

export const ContentBlocks = React.memo(_ContentBlocks);
